export const getYoutubePlaylistId = (url: string) => {
  if (!url) return null
  const playlistId = url.replace(/^.*list=/, '').replace(/\\&.*$/, '')
  return playlistId
}
export const getYoutubeVideoId = url => {
  if (!url) return null;
  let regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)(?:\?v=|\/))|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  let match = url.match(regExp);
  return (match && match[1].length === 11) ? match[1] : false;
}

/**
 * Prensa | getTweetId
 * @param url Expects an https tweet url
 * @example 
 * https://twitter.com/${user}/status/${tweetId}
 * https://twitter.com/${user}/status/${tweetId}?ref_src=${...}
 * @returns tweetId
 */
 export function getTweetId(url: string) {
  if (!url) return null
  let split_a = url.split('/')
  let split_b = split_a[split_a.length - 1].split('?')
  return split_b[0]
}

export function getTiktokId(url: string) {
  const regex = /cite="([^"]*)"/;
  const match = regex.exec(url);
  if (match) {
    return match[1];
  } else{
    return ''
  }
}